export const isTokenEmpty = (token) =>
  (typeof token === 'object' && Object.keys(token).length === 0) ||
  typeof token === 'undefined' ||
  !token;
